<template>
    <div class="main" id="mainwrap">
        <download-Popup></download-Popup>
        <p class="operamini-tips" v-if="isOperamini">In order to give you a better experience, please download our
            professional APP.</p>
        <downloadHeader v-once v-if="!isInApp" id="headwrap"></downloadHeader>
        <headerTitle :title="articleBody.title" :time="articleBody.time" :writer="articleBody.writer"
                     :afhao="articleBody.afh_info" v-if="articleBody.title"></headerTitle>
        <articleCon :bodydata="articleBody.body" :afhao="articleBody.afh_info" v-if="articleBody.body"></articleCon>
        <infos :infos="articleBody.infos" v-if="articleBody.infos"></infos>
        <relatedNews :articleId="articleBody.article_id" v-if="loadItem"></relatedNews>
        <comments :articleId="articleBody.article_id" :time="3000" v-if="loadItem"></comments>
        <downloadFooter v-once v-if="bodyLoad&&loadItem&&!isInApp"
                        text="Download All Football for more comments"></downloadFooter>
        <div class="links">Links：<a href="http://footballlive.cc/">Football Live | Football Results | Player Scored</a></div>
    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import downloadHeader from '@/components/downloadHeader.vue';
    import downloadFooter from '@/components/downloadFooter.vue';
    import headerTitle from '@/components/headerTitle.vue';
    import articleCon from '@/components/articleCon.vue';
    import infos from '@/components/infos.vue';
    import relatedNews from '@/components/relatedNews.vue';
    import comments from '@/components/comments.vue';
    import downloadPopup from '@/components/downloadPopup.vue';
    import axios from 'axios';

    export default {
        name: 'app',
        data () {
            return {
                imgMode: 'loading',
                isInApp: process.env.VUE_ENV === 'server' ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL,
                title: '',
                time: '',
                writer: '',
                copyright: '',
                new_video_detail: 0,
                con: [],
                infos: {
                    channels: [],
                    column: {}
                },
                // article_id:this.articlebody.article_id,
                article_id: parseInt(this.$route.params.id, 10),
                bodyLoad: false,
                tag: [],
                loadItem: false,
                isOperamini: false
            };
        },
        computed: {
            articleBody () {
                return this.$store.state.articlebody[this.article_id] || {};
            },
            relative () {
                return this.$store.state.relative[this.article_id];
            },
            comments () {
                return this.$store.state.comments[this.article_id];
            }
        },
        asyncData ({ store, route: { params: { id } } }) {
            // 此函数会在组件实例化之前执行，故直接将store,route传入；
            if (id) {
                return store.dispatch('FETCH_ARTICLEBODY', { article_id: id });
            } else {
                return Promise.reject();
            }
            // 多个时的写法
            // return Promise.all([
            // store.dispatch("FETCH_ARTICLEBODY",id),
            // store.dispatch("FETCH_COMMENTS",id),
            // store.dispatch("FETCH_RELATIVE",id)
            // ])
        },
        head () {
            const query = this.$route.query || {};
            const HOST = process.env.NODE_ENV === 'production' ? 'https://m.allfootballapp.com' : 'https://test-m.allfootballapp.com';
            const title = this.articleBody.title + '| All Football';
            const articleId = this.articleBody.article_id;
            const match = this.articleBody.body && this.articleBody.body.match(/<img[^>]+data-src\="([^"]+)"/);
            const p1 = this.articleBody.body && this.articleBody.body.match(/<(.*?)>(.*?)<\/\1>/);
            const shareUrl = HOST + this.$route.fullPath;
            const shareImg = match && match[1] ? match[1] : 'http://img.allfootballapp.com/www/M00/52/A6/rB8CLF1hHy2AWL55AAm0BGPys88585.png';
            const description = p1 && p1[2] ? p1[2] : 'Visit All Football to get football news, live scores, highlights, videos and commentary for EPL, La Liga, Bundesliga, Serie A';
            let keywords = 'All Football';

            if (this.articleBody.infos && this.articleBody.infos.channels) {
                keywords = this.articleBody.infos.channels.map(item => item.tag).join(',');
            }
            const link = [];
            if (this.$route.fullPath && this.$route.fullPath.indexOf('/news' === 0)) {
                link.push({
                    rel: 'amphtml',
                    href: HOST + '/amp' + this.$route.fullPath
                });
            }
            // 域名归一（阶段1）：声明规范版本在 www；纯 ID 形式由 www 301 到带 slug 规范页。
            // 仅在文章数据加载成功时输出，接口失败的兜底页不发 canonical
            if (articleId) {
                link.push({
                    vmid: 'canonical',
                    rel: 'canonical',
                    href: 'https://www.allfootballapp.com/articles/' + articleId
                });
            }

            return {
                title,
                link,
                meta: [
                    {
                        name: 'description',
                        content: description.replace(/<(.*?)>/g, '')
                    },
                    {
                        name: 'keywords',
                        content: keywords
                    },
                    { name: 'twitter:card', content: 'summary_large_image' },
                    { name: 'twitter:site', content: '@allfootballapp' },
                    { name: 'twitter:creator', content: '@allfootballapp' },
                    { name: 'twitter:app:id:ipad', content: '' },
                    { name: 'twitter:title', content: title },
                    { name: 'twitter:description', content: title },
                    { name: 'twitter:image', content: shareImg },
                    // facebook
                    { name: 'fb:app_id', content: 'summary_large_image' },
                    { name: 'og:url', content: shareUrl },
                    { name: 'og:type', content: 'article' },

                    // for twiter and facebook
                    { name: 'og:title', content: title },
                    { name: 'og:description', content: title },
                    { name: 'og:image', content: shareImg },
                    { name: 'og:site_name', content: 'AllfootballOfficial' }
                ]
            };
        },
        created: function () {
        },
        mounted: function () {
            // 分享页历史重置
            const query = this.$route.query || {};
            if (window.history && query.type && query.type === 'share') {
                const fullPath = this.$route.fullPath;
                history.replaceState(null, 'share', '/home?utm_source=APP_SHARE');
                history.pushState(null, 'share', fullPath);

                window.addEventListener('popstate', function (event) {
                    if (location.pathname !== '/news') {
                        location.reload();
                    }
                });
            }

            let mainwrap = document.getElementById('mainwrap');
            console.log('页面高度：' + mainwrap.offsetHeight);
            // 页面跳转到文章页 滚动条位置受前一页影响
            // window.scrollTo(0,0);
            if (!this.articleBody) return;
            // this.createDomData(this.articleBody.body);
            this.bodyLoad = true;
            // for (let k in response.data) {
            //     Vue.set(this, k, response.data[k]);
            // }
            if (!this.articleBody.infos) return;

            let channels = this.articleBody.infos.channels;
            for (let i = 0, len = channels.length; i < len; i++) {
                Vue.set(this.infos.channels, i, channels[i]);
            }
            Vue.set(this.infos, 'column', this.articleBody.infos.column);

            if (mainwrap.offsetHeight - window.screen.height - 100 > 0) {
                this.loadItem = false;
                window.addEventListener('scroll', this.loadmoreFn, false);
            } else {
                this.loadItem = true;
            }
            let utilObj = require('@/util/util.js');
            utilObj.timeForInOut();
            this.isOperamini = false;
        },
        methods: {
            loadmoreFn: function () {
                if ((document.documentElement.scrollTop || document.body.scrollTop) > 10) {
                    if (this.loadItem) return;
                    this.loadItem = true;
                    window.removeEventListener('scroll', this.loadmoreFn, false);
                }
            }
        },
        components: {
            downloadHeader, downloadFooter, headerTitle, articleCon, infos, relatedNews, comments, downloadPopup
        }
    };
</script>

<style scoped lang="less">
    .operamini-tips {
        background: #FFFF00;
        text-align: center;
        font-weight: bold;
    }
    .links {
        font-size: 14px;
        padding: 0 15px 0 15px;
        color: #fff;
        a {
               color: #fff;
           }
    }
</style>



// WEBPACK FOOTER //
// AppNews.vue?57318236